// ----------------------------------------------------------------------------
// Template: Pages
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

//Scripts
import 'sections/header/header';
import 'sections/headline-block/headline-block';
import 'sections/hero-banner/hero-banner';
import 'sections/hero-carousel/hero-carousel';
import 'sections/intro-block/intro-block';
import 'sections/content-panel/content-panel';
import 'sections/feature-panel/feature-panel';
import 'sections/icon-block/icon-block';
import 'sections/banner/banner-block';
import 'sections/video-image-banner/video-image-banner';
import 'sections/faqs/faqs';
import 'sections/tabs/tabs';
import 'sections/tabs/tabs--stores';
import 'sections/collection-list/collection-list';
import 'sections/product-slider/product-slider';
import 'sections/blog-posts/blog-posts';
import 'sections/newsletter/newsletter';
import 'sections/page-header/page-header';
import 'sections/rich-text/rich-text';
import 'sections/main-headline/main-headline';
import 'sections/featured-product/featured-product';
import 'sections/press-block/press-block';
import 'sections/press-quotes/press-quotes';
import 'sections/footer/footer';
import 'sections/guarantee-bar/guarantee-bar';
import 'sections/campaign-grid/campaign-grid';
import 'sections/expandable-cards/expandable-cards';
import 'sections/fit-cards/fit-cards';
import 'sections/scrolling-gallery/scrolling-gallery';
import 'sections/location-finder/location-finder';
import 'sections/two-column-block/two-column-block';
import 'sections/animation-block/animation-block';
import 'sections/stores/stores';
import 'sections/promo-tiles/promo-tiles';
import 'sections/hp-sustainability/hp-sustainability';
import 'sections/page-tabs/page-tabs';
import 'sections/image-product-grid/image-product-grid';
import 'snippets/country-modal/country-modal';

// Styles
import './_pages.scss';
